// components/NotFound.js (Tailwind Only Version)
import { Link } from "react-router-dom";
import { FaHome, FaArrowLeft, FaPhoneAlt, FaBolt } from "react-icons/fa";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 relative overflow-hidden font-sans">
      {/* Dynamic Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-green-700/5 rounded-full"
            style={{
              width: `${50 + Math.random() * 150}px`,
              height: `${50 + Math.random() * 150}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animation: `float ${20 + Math.random() * 10}s ease-in-out infinite`,
            }}
          />
        ))}
        {/* Bolt Icons as backgrounds */}
        <FaBolt className="absolute top-20 left-10 text-green-700/5 text-[200px] -rotate-12" />
        <FaBolt className="absolute bottom-20 right-10 text-yellow-500/5 text-[150px] rotate-12" />
      </div>

      {/* Error Content */}
      <div className="relative z-10 max-w-3xl w-full text-center">
        {/* Error Icon */}
        <div className="flex justify-center mb-12">
          <div className="relative group">
            <div className="w-40 h-40 bg-black rounded-[3rem] flex items-center justify-center shadow-2xl transform group-hover:rotate-12 transition-transform duration-500">
              <span className="text-white text-7xl font-black">?</span>
            </div>
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center shadow-xl animate-bounce">
              <FaBolt size={24} className="text-black" />
            </div>
          </div>
        </div>

        {/* Error Number */}
        <div className="mb-8">
          <h1 className="text-[12rem] font-black leading-none uppercase tracking-tighter text-black">
            404
          </h1>
          <div className="w-32 h-3 bg-yellow-400 mx-auto rounded-full"></div>
        </div>

        {/* Error Message */}
        <h2 className="text-4xl md:text-5xl font-black text-black mb-6 uppercase tracking-tight">
          System <span className="text-green-700">Offline</span>
        </h2>
        <p className="text-xl text-gray-500 mb-12 max-w-2xl mx-auto font-medium leading-relaxed">
          Oops! The page you're looking for seems to have been disconnected.
          It might have been moved, deleted, or perhaps there was a power
          outage in our servers.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center mb-20">
          <Link
            to="/"
            className="group bg-green-700 text-white font-black uppercase tracking-widest text-xs px-12 py-6 rounded-2xl shadow-2xl hover:bg-black transition-all duration-300 flex items-center justify-center gap-4"
          >
            <FaHome size={18} />
            <span>Go To Homepage</span>
          </Link>

          <button
            onClick={() => window.history.back()}
            className="group bg-white text-black border-2 border-black font-black uppercase tracking-widest text-xs px-12 py-6 rounded-2xl shadow-xl hover:bg-gray-50 transition-all duration-300 flex items-center justify-center gap-4"
          >
            <FaArrowLeft size={18} />
            <span>Return Back</span>
          </button>
        </div>

        {/* Quick Help Strip */}
        <div className="bg-black text-white p-10 rounded-[3rem] shadow-2xl flex flex-col md:flex-row items-center justify-between gap-8 mb-12 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-32 h-32 bg-green-700/20 rounded-full -mr-16 -mt-16"></div>
          <div className="text-center md:text-left relative z-10">
            <h4 className="text-xl font-black uppercase tracking-tight mb-2">Need immediate assistance?</h4>
            <p className="text-gray-400 font-medium">Our emergency response team is available 24/7.</p>
          </div>
          <div className="flex items-center gap-4 bg-[#14532d] px-8 py-4 rounded-2xl shadow-lg relative z-10 group-hover:scale-105 transition-transform">
            <FaPhoneAlt className="text-yellow-400" />
            <span className="text-2xl font-black">0700 000 2332</span>
          </div>
        </div>

        {/* Quick Links */}
        <div className="pt-12 border-t border-gray-100 flex flex-wrap justify-center gap-x-12 gap-y-6">
          {['Customer Care', 'Tariff', 'Metering', 'Contact'].map(link => (
            <Link
              key={link}
              to={`/${link.toLowerCase().replace(' ', '-')}`}
              className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 hover:text-green-700 transition-colors"
            >
              {link}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NotFound;